import { cn } from '@/lib/utils';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
	children: React.ReactNode;
	hoverable?: boolean;
	className?: string;
}

const Card = ({
	children,
	className,
	hoverable = true,
	...props
}: CardProps) => {
	return (
		<div
			className={cn(
				"bg-background-light border border-background-default rounded-2xl p-4 transition-all",
				hoverable && "hover:border-border-dark",
				hoverable && "hover:bg-background-dark",
				className,
			)}
			{...props}
		>
			{children}
		</div>
	);
};

export default Card;